import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';
import { List, Map } from 'immutable';

import config from '../../../../config';
import FormGroup from '../../../helpers/FormGroup';
import Select from '../../../helpers/Select';
import { CompanyBuyerLeadsTable } from './CompanyBuyerLeadsTable';
import { Card } from '../../../helpers/Card';

import style from './style.module.css';

const columnDefs = config.tables.getIn(['companyBuyerLeads', 'columnDefs']);

const CompanyBuyerLeadsComponent = ({
  leads,
  statuses,
  onDoubleClickRow,
  onGetNextPageData,
  onCurrentStatusChange,
  onChange,
  isDuplicateCompany,
}) => (
  <div className={classNames(style.host, 'flexWrapper full-height flexItem')}>
    <Card className={style.filters}>
      <FormGroup className={style.status}>
        <Select
          disabled={isDuplicateCompany}
          id="buyer-leads-current-status"
          label="Current Status"
          name="currentStatus"
          onChange={onCurrentStatusChange}
          options={statuses}
          value={leads.getIn(['status', 'selected'])}
          showLabel
        />
      </FormGroup>
    </Card>
    <CompanyBuyerLeadsTable
      columnDefs={columnDefs}
      data={leads}
      onChange={onChange}
      onDoubleClickRow={onDoubleClickRow}
      onGetNextPageData={onGetNextPageData}
    />
  </div>
);

CompanyBuyerLeadsComponent.propTypes = {
  isDuplicateCompany: PropTypes.bool.isRequired,
  leads: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
  onCurrentStatusChange: PropTypes.func.isRequired,
  onDoubleClickRow: PropTypes.func.isRequired,
  onGetNextPageData: PropTypes.func.isRequired,
  statuses: PropTypes.instanceOf(List).isRequired,
};

/** Company buyer leads component. */
export const CompanyBuyerLeads = memo(CompanyBuyerLeadsComponent);
